import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeUpAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe_up_alt"}/>
}
